import React, { FC } from 'react';

import { washHub } from 'store/slices';

import { EmployeesTable } from './EmployeesTable';

export const WashHubAdmins: FC = () => {
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();

  return (
    <EmployeesTable
      queryKeyPrefix={`fetch-employees-${washHubId}`}
      washHubId={washHubId}
      enabled={isWashHubIdValid}
      resetPageOnWashHubChange
    />
  );
};
